<template>
  <div class="services-container">
    <h1 class="title">Our Services</h1>
    <div class="chiclet-grid">
      <div
          v-for="service in services"
          :key="service.name"
          class="chiclet">
<!--          @click="navigateTo(service.route)"-->
<!--      >-->
        <component :is="service.icon" class="icon"/>
        <p class="service-name">{{ service.name }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
// import { useRouter } from 'vue-router'

// Import service icons (we will create SVGs for each)
import AIIcon from '@/assets/icons/AIIcon.vue'
import DataIcon from '@/assets/icons/ETLIcon'
// import ETLIcon from '@/assets/icons/ETLIcon.vue'
import APIIcon from '@/assets/icons/APIIcon.vue'
import MicroservicesIcon from '@/assets/icons/MicroservicesIcon.vue'
import EnterpriseIcon from '@/assets/icons/EnterpriseIcon.vue'

// const router = useRouter()

const services = [
  { name: "AI / ML", route: "/services/ai-ml", icon: AIIcon },
  { name: "Data", route: "/services/data", icon: DataIcon },
  // { name: "ETL / ELT", route: "/services/etl-elt", icon: ETLIcon },
  { name: "API-Led Architectures", route: "/services/api_led", icon: APIIcon },
  { name: "Microservices", route: "/services/microservices", icon: MicroservicesIcon },
  { name: "Enterprise Architecture", route: "/services/enterprise_architecture", icon: EnterpriseIcon },
]

// const navigateTo = (route) => {
//   router.push(route)
// }
</script>

<style scoped>
/* Services Page Container */
.services-container {
  max-width: 1200px;
  margin: auto;
  padding: 20px;
  text-align: center;
}

/* Title */
.title {
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: white;
}

/* 📌 Mobile-First Grid */
.chiclet-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  justify-content: center;
}

/* Chiclet Design */
.chiclet {
  background: #f4f4f4;
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 120px;
}

.chiclet:hover {
  background: #e0e0e0;
  transform: scale(1.05);
}

/* Icon Styling */
.icon {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

/* Service Name */
.service-name {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

/* 📌 Responsive Design */
@media screen and (max-width: 768px) {
  .chiclet-grid {
    grid-template-columns: 1fr; /* Stack chiclets on mobile */
  }

  .title {
    font-size: 1.5rem;
  }

  .chiclet {
    min-height: 100px;
    padding: 10px;
  }

  .icon {
    width: 40px;
    height: 40px;
  }
}
</style>
